<template>
	<EMCoreTemplate category="OSMLife" identity="commissionOverride" entity="osm_commission_override"></EMCoreTemplate>
</template>
<script type="text/javascript">
	import {EMCoreTemplate} from '@/Adm/components' 
	export default{
		components:{
			EMCoreTemplate
		}	
	}

</script>


// WEBPACK FOOTER //
// src/Adm/EntityManagementLife/containers/CommissionOverride.vue